import { defineSetting } from '../../../settingsRegistry';
import { setFigureB3 } from './flag';

declare module '../../../settingsRegistry' {
  interface Settings {
    /**
     * Which figure proportion the game draws (user 10-11): 0 = B3 (today's, head ×0.75, taller, the player's
     * hand-drawn skull), 1 = the figure before B3 (bigger head, as the face lab draws it). Every figure on this
     * screen; frames already drawn stay, so a change reloads the page.
     */
    figureLook: number;
  }
}

defineSetting({
  key: 'figureLook',
  default: 0,
  order: 126,
  range: [0, 1],
  menu: {
    group: 'visual',
    label: 'รูปร่างตัวละคร',
    choices: ['สัดส่วนปัจจุบัน (หัวเล็ก)', 'แบบก่อนหน้า (หัวโต)'],
    changed: (v) => {
      setFigureB3(v === 0);
      // the menu saves right after this call; reload once it has, so every figure is drawn again
      setTimeout(() => location.reload(), 50);
    },
    note: () => 'เปลี่ยนแล้วเกมจะโหลดใหม่',
  },
});

// The saved value, once the settings are loaded (lazy, as cloth.setting.ts: no static import of settings.ts here).
void import('../../../settings')
  .then((s) => setFigureB3(s.settings.figureLook === 0))
  .catch(() => {}); // no settings outside a page (node tests): keep the build default
